<div class="page traveler">
  @if ($job | async; as job) {
    <mat-card>
      <mat-card-header style="justify-content: space-between;">
        <mat-card-title>Summary</mat-card-title>
        @if (polling) {
          <div class="polling-indicator" matTooltip="Checking job status"></div>
        }
      </mat-card-header>
      <mat-card-content>
        <div class="summary-container">
          <div class="item">
            <h4 class="title">Status</h4>
            <src-job-status [status]="job.attributes.status"></src-job-status>
          </div>
          <div class="item">
            <h4 class="title">Submitted On</h4>
            <src-pretty-date [value]="job.attributes.created_on"></src-pretty-date>
          </div>
          <div class="item">
            <h4 class="title">Submitted By</h4>
            <p>{{job.attributes.created_by_name + ' ' + (job.attributes.created_by_lastname || '')}}</p>
          </div>
          <div class="item">
            <h4 class="title">Last Change</h4>
            <src-pretty-date [value]="job.attributes.changed_on"></src-pretty-date>
          </div>
          <div class="item">
            <h4 class="title">Job Type</h4>
            <p>{{job.attributes.type | jobType}}</p>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <br>
    <mat-card>
      <mat-card-header>
        <div class="json-header">
          <mat-card-title>Parameters</mat-card-title>
          <mat-slide-toggle (change)="inputViewJson=$event.checked" matTooltip="View JSON or Pretty render">JSON
          </mat-slide-toggle>
        </div>
      </mat-card-header>
      <mat-card-content>
        @if (inputViewJson) {
          <pre class="json-view">{{job.attributes.input_data | json}}</pre>
        } @else {
          @switch (job.attributes.type) {
            @case ('series_correction') {
              <series-correction-job-input-data
                  [inputData]="job.attributes.input_data"
              ></series-correction-job-input-data>
            }
          }
        }
      </mat-card-content>
    </mat-card>
    <br>
    <mat-card>
      <mat-card-header>
        <div class="json-header">
          <mat-card-title>Report</mat-card-title>
          <mat-slide-toggle [disabled]="outputMissing" (change)="outputViewJson=$event.checked"
                            [matTooltip]="outputMissing?'No output data on job. Is it still busy or had an error?' : 'View JSON or Pretty render'">
            JSON
          </mat-slide-toggle>
        </div>
      </mat-card-header>
      <mat-card-content>
        <p>{{reportMessage}}</p>
        @switch (job.attributes.status) {
          @case ('error') {
            @if (outputViewJson) {
              <pre class="json-view">{{job.attributes.output_data | json}}</pre>
            } @else {
              <src-job-error-output [outputData]="job.attributes.output_data"></src-job-error-output>
            }
          }
          @case ('completed') {
            @if (outputViewJson) {
              <pre class="json-view">{{job.attributes.output_data | json}}</pre>
            } @else {
              @switch (job.attributes.type) {
                @case ('series_correction') {
                  <series-correction-job-output-data
                      [outputData]="job.attributes.output_data"></series-correction-job-output-data>
                }
              }
            }
          }
        }
      </mat-card-content>
    </mat-card>
  } @else {
    <div class="loading-info-row">
      @if (!was_missing) {
        <h2 class="loading">Loading job...</h2>
      } @else {
        <div class="not-found-column">
          <h2 class="warning">
            Could not find Job with ID {{job_id}}
          </h2>
          <p>Please make sure the job exists or that the correct ID was provided.</p>
        </div>
      }
    </div>
  }
</div>
